import { Rsvp, FoodPreference } from "api/RsvpApi";
import { YesNoMaybe } from "types/YesNoMaybe";

// TODO: Irgendwo zentral ablegen
export const TRANSLATIONS = {
    Going: 'Zusagen',
    NotGoing: 'Absagen',
    Meat: 'Omnomnomnivore',
    Vegan: 'Vegan',
    Vegetarian: 'Vegetarisch',
    yes: 'Ja',
    no: 'Nein',
    maybe: 'Weiß nicht'
} as Record<Rsvp | FoodPreference | YesNoMaybe, string>;